import request from '@/utils/request'

// 入库单列表
export function warupList(data) {
    return request({
        url: '/oms/stockIn/list',
        method: 'post',
        data: data
    })
}

// 入库单详情
export function warupDel(params) {
	return request({
		url: '/oms/stockIn/detail',
		method: 'get',
		params: params
	})
}

// 下载采购单模板
export function downloadTemplate() {
	return request({
		url: '/oms/stockIn/import/template',
		method: 'GET',
		responseType: 'blob'
	})
}

// 导入采购单模板
export function importStock(data) {
	return request({
		url: '/oms/stockIn/import',
		method: 'POST',
		data
	})
}

// 采购人列表
export function getAllAdminList () {
	return request({
		url: '/scm/dict/list',
		method: 'get'
	})
}



// WEBPACK FOOTER //
// ./src/api/sms/warup.js